export default "__VITE_ASSET__CNW3NOLk__"